/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/adobexd" */ '@atlassian/logo-third-party/adobexd'
		).then((m) => m.AdobeXDIcon),
	{ moduleId: '@atlassian/logo-third-party/adobexd' },
);

const LazyAdobeXDIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-adobe-xd" */ './utils').then((m) => m.AdobeXDIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-xd/icon' },
);

const LazyAdobeXDSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-adobe-xd-search-result" */ './utils').then(
			(m) => m.AdobeXDSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-xd/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AdobeXDIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyAdobeXDIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const AdobeXDSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyAdobeXDSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
